export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-02.ca32948b.png";